import { render, staticRenderFns } from "./paginator.vue?vue&type=template&id=614da27e&scoped=true&"
import script from "./paginator.vue?vue&type=script&setup=true&lang=js&"
export * from "./paginator.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./paginator.vue?vue&type=style&index=0&id=614da27e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614da27e",
  null
  
)

export default component.exports